module.exports = __webpack_public_path__ + "img/ttm-logo-icon.54fc2f90.png";